import useObjectAccessState from './useObjectAccessState';

export const useCanSaveObjectAccess = () => {
  const [state] = useObjectAccessState();

  return JSON.stringify(state.items) !== JSON.stringify(state.initial);
};

export default useCanSaveObjectAccess;